import clsx from 'clsx';
import { useStore } from '../lib/store';
import { StepContact } from './steps/step-contact';
import { StepOffer } from './steps/step-offer';
import { StepCompany } from './steps/step-company';
import styles from './index.module.css';

const App = () => {
  const { step } = useStore();

  const getStatus = (num) => step === num ? 'active' 
    : step > num ? 'complete' : 'disabled';

  return (
    <>
    <div className={clsx(
      styles.sequenceWrapper,
    )}>
      <div className={clsx(
        styles.radialGradient,
        step > 1 ? styles['is-disabled'] : styles['is-active']
      )}>
        <div className={styles.radialGradientInner}></div>
      </div>
      <div className={clsx(
        styles.sequence,
        step > 3 && styles['is-complete']
      )}>
        <div className={styles.wrapper}>
          <StepContact 
            title="Contact Information"
            number={1}
            status={getStatus(1)}
          />
          <StepCompany
            title="Company Information"
            number={2}
            status={getStatus(2)}
          />
          <StepOffer
            title="Offer Details"
            number={3}
            status={getStatus(3)}
            isLast
          />
        </div>
      </div>
    </div>
    </>
  )
}

export default App;